var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge d-flex align-items-center justify-content-center",class:_vm.classes,style:(_vm.badgeStyle),on:{"click":_vm.click}},[_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }